// extracted by mini-css-extract-plugin
module.exports = {"layout":"bar-chart_layout__uNXZ3","field":"bar-chart_field__w3tVz","barContainer":"bar-chart_barContainer__dwLHg","bar":"bar-chart_bar__hVb_7","value":"bar-chart_value__fDNKR"};